import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {ButtonComponent} from './button/button.component'
import {RouterModule} from '@angular/router'
import {CheckboxComponent} from './checkbox/checkbox.component'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {SurveyComponent} from './survey/survey.component'
import {TextLinkComponent} from './text-link/text-link.component'
import {InputComponent} from './input/input.component'
import {CookieService} from 'ngx-cookie-service'
import {SelectComponent} from './select/select.component'
import {RadioComponent} from './radio/radio.component'
import {EventsComponent} from './events/events.component'
import {NgbNavModule, NgbAccordionModule} from '@ng-bootstrap/ng-bootstrap'
import {EventPipe} from '../../pipes/event.pipe'
import {SharedModule} from '../shared/shared.module'
import {InputInsideValidationsComponent} from './input-inside-validations/input-inside-validations.component'
import {SelectInsideValidationsComponent} from './select-inside-validations/select-inside-validations.component'
import {StepNumberComponent} from './step-number/step-number.component'
import {StepDetailsComponent} from './step-details/step-details.component'
import {TextAreaComponent} from './textArea/textArea.component'
import {CaptchaComponent} from './captcha/captcha.component'
import {FileComponent} from './file/file.component'
import {NgxCaptchaModule} from 'ngx-captcha'
import {FileListComponent} from './file/file-list/file-list.component'
import {PipesModule} from '../../pipes/pipes.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbAccordionModule,
    NgbNavModule,
    SharedModule,
    NgxCaptchaModule,
    PipesModule
  ],
  declarations: [
    ButtonComponent,
    CheckboxComponent,
    SurveyComponent,
    TextLinkComponent,
    InputComponent,
    TextAreaComponent,
    InputInsideValidationsComponent,
    SelectComponent,
    SelectInsideValidationsComponent,
    RadioComponent,
    EventsComponent,
    StepNumberComponent,
    StepDetailsComponent,
    EventPipe,
    CaptchaComponent,
    FileComponent,
    FileListComponent
  ],
  exports: [
    ButtonComponent,
    CheckboxComponent,
    SurveyComponent,
    TextLinkComponent,
    InputComponent,
    TextAreaComponent,
    InputInsideValidationsComponent,
    SelectComponent,
    SelectInsideValidationsComponent,
    RadioComponent,
    EventsComponent,
    StepNumberComponent,
    StepDetailsComponent,
    CaptchaComponent,
    FileComponent,
    FileListComponent
  ],
  providers: [
    CookieService
  ]
})
export class FormModule {
}
